/**
 *
 * AcceptedTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import PinTripIcon from 'assets/v2/PinTripIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.myrtleGreenDark};
    background: ${COLORS.myrtleGreenLight};
    border-color: ${COLORS.myrtleGreen};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.myrtleGreen};
    }
  }
`;

function AcceptedTag(props) {
  return <StyledTag label="Accepted" icon={<PinTripIcon />} {...props} />;
}

export default memo(AcceptedTag);
